import React from "react";
import { TID } from "@/lib/testIds";

export default function WhatsAppButton({ phone = "918817725280" }) {
  const href = `https://wa.me/${phone}?text=${encodeURIComponent(
    "Hi, I want to know more about Bajrang Veda"
  )}`;
  return (
    <a
      data-testid={TID.whatsappBtn}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-24 right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] shadow-[0_10px_30px_rgba(37,211,102,0.45)] transition-transform hover:scale-110 sm:bottom-28"
    >
      <svg width="28" height="28" viewBox="0 0 32 32" fill="white" aria-hidden="true">
        <path d="M16.003 3C9.376 3 4 8.376 4 15c0 2.116.554 4.184 1.607 6L4 28l7.223-1.583A11.94 11.94 0 0 0 16.003 27c6.627 0 12.003-5.376 12.003-12S22.63 3 16.003 3zm0 21.6c-1.85 0-3.658-.5-5.235-1.446l-.375-.223-4.293.94.918-4.183-.244-.386A9.6 9.6 0 1 1 25.6 15c0 5.303-4.294 9.6-9.597 9.6zm5.523-7.183c-.303-.152-1.793-.885-2.07-.986-.278-.101-.48-.152-.68.152-.202.303-.782.985-.959 1.187-.176.203-.353.228-.656.076-.303-.152-1.28-.472-2.44-1.505-.902-.804-1.51-1.797-1.687-2.1-.176-.303-.019-.467.133-.618.137-.136.303-.354.454-.53.152-.177.202-.303.303-.505.101-.202.05-.379-.025-.53-.076-.152-.681-1.646-.933-2.253-.246-.593-.497-.513-.68-.522l-.58-.011c-.202 0-.53.076-.807.379s-1.06 1.035-1.06 2.523 1.086 2.929 1.238 3.13c.152.203 2.135 3.266 5.176 4.577.723.313 1.288.5 1.729.64.726.23 1.386.198 1.909.121.583-.087 1.793-.732 2.046-1.44.253-.708.253-1.315.177-1.44-.076-.126-.278-.202-.58-.354z" />
      </svg>
    </a>
  );
}
